export default __webpack_public_path__ + "static/b5-0beaba53ce00917df52427df05d2f63d.png";